module.exports = __webpack_public_path__ + "img/8.79b94cc1.jpg";